import { render } from "./MesDevoirsPage.vue?vue&type=template&id=bfb77442&ts=true"
import script from "./MesDevoirsPage.vue?vue&type=script&lang=ts"
export * from "./MesDevoirsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__